module.exports = __webpack_public_path__ + "img/swiper_08.3b9d3e1a.jpg";